@switch (state().mode) {
  @case ('List') {
    <tiime-container class="list-container" [containerState]="state().containerState">
      <div class="document-requests-header" tiimeContainerHeader>
        <div class="title" tiimeContainerHeaderLeft>Demande de pièce bilan</div>
        <div tiimeContainerHeaderRight>
          <tiime-table-loader [isLoading]="state().isLoading"></tiime-table-loader>
          <button tiime-button icon color="primary" (click)="emitClosePanel()">
            <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
          </button>
        </div>
      </div>
      <div tiimeContainerHeader>
        <div tiimeContainerHeaderLeft>
          <tiime-search-bar
            dark
            placeholder="Rechercher..."
            [debounceTime]="0"
            [disabled]="disabledActions()"
            (search)="applySearch($event)"
          ></tiime-search-bar>
        </div>
        <div tiimeContainerHeaderRight>
          <tiime-paginator
            [range]="state().pagination"
            [disabled]="state().containerState !== ContainerState.done"
            (rangeEvent)="applyRange($event)"
          ></tiime-paginator>
          <app-document-request-filters-button
            [form]="filtersForm"
            [filters]="state().filters"
            [accountingPeriods]="accountingPeriods()"
          ></app-document-request-filters-button>
          <app-refresh-button [disabled]="state().isLoading" (refresh)="refreshList()"></app-refresh-button>
        </div>
      </div>
      <div tiimeContainerContent>
        @for (documentRequest of state().data; track documentRequest.id) {
          <app-document-request
            [documentRequest]="documentRequest"
            (selectDocumentRequest)="detailsDocumentRequestMode(documentRequest)"
            (openOrCloseDocumentRequest)="openOrCloseDocumentRequest(documentRequest)"
          ></app-document-request>
          <div class="separator"></div>
        }
      </div>
      <tiime-sticky-table-content-placeholder tiimeContainerContentPlaceholder></tiime-sticky-table-content-placeholder>
      <tiime-sticky-table-no-results tiimeContainerNoResult></tiime-sticky-table-no-results>
      <tiime-empty-state tiimeContainerOnboard>
        <img illu src="assets/illu_404_grey.svg" alt="empty document request" />
        <span label>Aucune demande de document</span>
      </tiime-empty-state>
      <div tiimeContainerFooter>
        <button tiime-button color="primary" raised (click)="createDocumentRequestMode()">Demander un document</button>
      </div>
    </tiime-container>
  }
  @case ('Creation') {
    <tiime-container [containerState]="state().containerState">
      <div class="document-requests-header" tiimeContainerHeader>
        <div tiimeContainerHeaderLeft>
          <button tiime-button icon color="primary" (click)="listDocumentRequestMode()">
            <mat-icon fontSet="fontastic" fontIcon="icon-ic-back"></mat-icon>
          </button>
          Demander un document
        </div>
        <div tiimeContainerHeaderRight>
          <tiime-table-loader [isLoading]="state().isLoading"></tiime-table-loader>
          <button class="close-button" tiime-button icon color="primary" (click)="emitClosePanel()">
            <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
          </button>
        </div>
      </div>
      <div class="document-requests-content" tiimeContainerContent>
        <app-document-request-form
          [documentRequestForm]="form"
          [firstOpenedAccountingPeriod]="firstOpenedAccountingPeriod()"
          [panelMode]="state().mode"
          [acceptedTypes]="acceptedTypes"
          [maximumSize]="maximumSize"
          (onFileSelected)="onFileSelected($event)"
          (onFileDeleted)="onFileDeleted()"
          (downloadTemplateFile)="downloadDocumentRequestTemplateFile($event)"
        ></app-document-request-form>
        <button class="document-requests-button" tiime-button color="primary" raised (click)="requestDocument()">
          Demander un document
        </button>
      </div>
    </tiime-container>
  }
  @case ('Detail') {
    <tiime-container [containerState]="state().containerState">
      <div class="document-requests-header" tiimeContainerHeader>
        <div tiimeContainerHeaderLeft>
          <button tiime-button icon color="primary" (click)="listDocumentRequestMode()">
            <mat-icon fontSet="fontastic" fontIcon="icon-ic-back"></mat-icon>
          </button>
          Détail de la demande
        </div>
        <div tiimeContainerHeaderRight>
          <tiime-table-loader [isLoading]="state().isLoading"></tiime-table-loader>
          <button tiime-button icon color="primary" (click)="emitClosePanel()">
            <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
          </button>
        </div>
      </div>
      <div class="document-requests-content" tiimeContainerContent>
        <app-document-request-detail
          [documentRequest]="state().selected"
          [accountingPeriod]="selectedAccountingPeriod()"
          (openOrCloseDocumentRequest)="openOrCloseDocumentRequest($event)"
          (downloadCustomerDocument)="downloadCustomerDocument($event)"
          (openCustomerDocumentInNewTab)="openCustomerDocumentInNewTab($event)"
        ></app-document-request-detail>
      </div>
    </tiime-container>
  }
}
